import { useState } from "react";
import { addOrEditPricing } from "../../utils/wellspoken.api";
import toast from "react-hot-toast";

export default function Pricing() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setMessage("");
  //   setError("");

  //   const formData = new FormData();
  //   formData.append("PlanId", "0");
  //   formData.append("PlanName", e.target.planName.value);
  //   // formData.append(
  //   //   "PlanFeature",
  //   //   JSON.stringify(e.target.features.value.split("\n"))
  //   // );
  //   const features = e.target.features.value
  //     .split("\n")
  //     .map(f => `"${f.trim()}"`)
  //     .join(",");

  //   formData.append("PlanFeature", features);
  //   formData.append("Pricetype", e.target.priceType.value);
  //   //formData.append("Pricetype", "");
  //   formData.append("Price", e.target.price.value);

  //   try {
  //     await addOrEditPricing(formData);
  //     toast.success("Pricing created successfully 🎉");
  //     // setMessage("Pricing plan saved successfully!");
  //     e.target.reset();
  //   } catch (err) {
  //     setError("Failed to save pricing plan. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const features = e.target.features.value
      .split("\n")
      .map(f => f.trim())
      .filter(Boolean);

    const payload = {
      PlanId: 0,
      PlanName: e.target.planName.value,
      PlanFeature: features.join("\n"), // or array if backend allows
      Pricetype: e.target.priceType.value,
      Price: e.target.price.value,
    };

    try {
      await addOrEditPricing(payload);
      toast.success("Pricing created successfully 🎉");
      e.target.reset();
    } catch (err) {
      setError("Failed to save pricing plan.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      className="min-h-screen bg-surface relative overflow-hidden"
      aria-labelledby="pricing-heading"
    >
      {/* Background Effects */}
      <div className="absolute inset-0 -z-10" aria-hidden="true">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-primary-light/10 rounded-full blur-3xl" />
      </div>

      {/* SEO Header */}
      <header className="text-center px-4 ">
        <h1
          id="pricing-heading"
          className="text-3xl md:text-4xl font-bold text-textPrimary"
        >
          Pricing Management
        </h1>
        <p className="mt-3 text-textSecondary max-w-2xl mx-auto">
          Create and manage subscription plans with clear pricing and features.
        </p>
      </header>

      {/* Form Section – FULL WIDTH */}
      <section
        className="
      w-full
      px-4 sm:px-6 lg:px-10
      pb-12
    "
        aria-label="Pricing form section"
      >
        <form
          onSubmit={handleSubmit}
          className="
        w-full
        bg-white
        rounded-2xl
        shadow-lg
        border border-border
        p-6 sm:p-10
        space-y-6
      "
          aria-describedby="pricing-heading"
        >
          {/* Plan Name */}
          <div>
            <label
              htmlFor="planName"
              className="block text-sm font-medium text-textPrimary"
            >
              Plan Name
            </label>
            <input
              id="planName"
              name="planName"
              type="text"
              required
              aria-required="true"
              placeholder="Weekly Starter Plan"
              className="
            mt-2 w-full rounded-lg
            border border-border
            px-4 py-3
            text-textPrimary
            focus:outline-none
            focus-visible:ring-2
            focus-visible:ring-primary
          "
            />
          </div>

          {/* Price */}
          <div>
            <label
              htmlFor="price"
              className="block text-sm font-medium text-textPrimary"
            >
              Price (INR)
            </label>
            <input
              id="price"
              name="price"
              type="number"
              required
              inputMode="numeric"
              placeholder="4900"
              className="
            mt-2 w-full rounded-lg
            border border-border
            px-4 py-3
            focus:outline-none
            focus-visible:ring-2
            focus-visible:ring-primary
          "
            />
          </div>

          {/* Price Type */}
          <div>
            <label
              htmlFor="priceType"
              className="block text-sm font-medium text-textPrimary"
            >
              Price Type
            </label>
            <input
              id="priceType"
              name="priceType"
              type="text"
              required
              placeholder="day / week / month"
              className="
            mt-2 w-full rounded-lg
            border border-border
            px-4 py-3
            focus:outline-none
            focus-visible:ring-2
            focus-visible:ring-primary
          "
            />
          </div>

          {/* Features */}
          <div>
            <label
              htmlFor="features"
              className="block text-sm font-medium text-textPrimary"
            >
              Plan Features
            </label>
            <textarea
              id="features"
              name="features"
              rows={4}
              required
              placeholder={`8 group classes\nHomework & review\nCommunity practice`}
              className="
            mt-2 w-full rounded-lg
            border border-border
            px-4 py-3
            focus:outline-none
            focus-visible:ring-2
            focus-visible:ring-primary
          "
            />
            <p className="mt-1 text-xs text-textSecondary">
              Enter one feature per line.
            </p>
          </div>

          {/* Feedback */}
          {message && (
            <p className="text-green-600 text-sm" role="status">
              {message}
            </p>
          )}
          {error && (
            <p className="text-red-600 text-sm" role="alert">
              {error}
            </p>
          )}

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full sm:w-auto rounded-xl
                       bg-gradient-to-r from-blue-600 to-indigo-600
                       px-6 py-3 text-white font-semibold
                       hover:from-blue-500 hover:to-indigo-500
                       focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-blue-500/40
                       disabled:opacity-60 transition"
          >
            {loading ? "Saving..." : "Save Pricing Plan"}
          </button>
        </form>
      </section>
    </main>

  );
}
